export const cities = [
  {
    country: 'United States',
    state: 'New York',
    cities: [
      {},
      { label: 'New York' },
      { label: 'Buffalo' },
      { label: 'Rochester' },
      { label: 'Yonkers' },
      { label: 'Syracuse' },
      { label: 'Albany' },
      { label: 'New Rochelle' },
      { label: 'Mount Vernon' },
      { label: 'Schenectady' },
      { label: 'Utica' },
      { label: 'White Plains' },
      { label: 'Hempstead' },
      { label: 'Troy' },
      { label: 'Niagara Falls' },
      { label: 'Binghamton' },
      { label: 'Freeport' },
      { label: 'Valley Stream' }
    ]
  },
  {
    country: 'United States',
    state: 'California',
    cities: [
      {},
      { label: 'Los Angeles' },
      { label: 'San Diego' },
      { label: 'San Jose' },
      { label: 'San Francisco' },
      { label: 'Fresno' },
      { label: 'Sacramento' },
      { label: 'Long Beach' },
      { label: 'Oakland' },
      { label: 'Bakersfield' },
      { label: 'Anaheim' },
      { label: 'Santa Ana' },
      { label: 'Riverside' },
      { label: 'Stockton' },
      { label: 'Chula Vista' },
      { label: 'Irvine' },
      { label: 'Fremont' },
      { label: 'San Bernardino' },
      { label: 'Modesto' },
      { label: 'Fontana' },
      { label: 'Oxnard' },
      { label: 'Moreno Valley' },
      { label: 'Huntington Beach' },
      { label: 'Glendale' },
      { label: 'Santa Clarita' },
      { label: 'Garden Grove' },
      { label: 'Oceanside' },
      { label: 'Rancho Cucamonga' },
      { label: 'Santa Rosa' },
      { label: 'Ontario' },
      { label: 'Lancaster' },
      { label: 'Elk Grove' },
      { label: 'Corona' },
      { label: 'Palmdale' },
      { label: 'Salinas' },
      { label: 'Pomona' },
      { label: 'Hayward' },
      { label: 'Escondido' },
      { label: 'Torrance' },
      { label: 'Sunnyvale' },
      { label: 'Orange' },
      { label: 'Fullerton' },
      { label: 'Pasadena' },
      { label: 'Thousand Oaks' },
      { label: 'Visalia' },
      { label: 'Simi Valley' },
      { label: 'Concord' },
      { label: 'Roseville' },
      { label: 'Victorville' },
      { label: 'Santa Clara' },
      { label: 'Vallejo' },
      { label: 'Berkeley' },
      { label: 'El Monte' },
      { label: 'Downey' },
      { label: 'Costa Mesa' },
      { label: 'Inglewood' },
      { label: 'Carlsbad' },
      { label: 'San Buenaventura (Ventura)' },
      { label: 'Fairfield' },
      { label: 'West Covina' },
      { label: 'Murrieta' },
      { label: 'Richmond' },
      { label: 'Norwalk' },
      { label: 'Antioch' },
      { label: 'Temecula' },
      { label: 'Burbank' },
      { label: 'Daly City' },
      { label: 'Rialto' },
      { label: 'Santa Maria' },
      { label: 'El Cajon' },
      { label: 'San Mateo' },
      { label: 'Clovis' },
      { label: 'Compton' },
      { label: 'Jurupa Valley' },
      { label: 'Vista' },
      { label: 'South Gate' },
      { label: 'Mission Viejo' },
      { label: 'Vacaville' },
      { label: 'Carson' },
      { label: 'Hesperia' },
      { label: 'Santa Monica' },
      { label: 'Westminster' },
      { label: 'Redding' },
      { label: 'Santa Barbara' },
      { label: 'Chico' },
      { label: 'Newport Beach' },
      { label: 'San Leandro' },
      { label: 'San Marcos' },
      { label: 'Whittier' },
      { label: 'Hawthorne' },
      { label: 'Citrus Heights' },
      { label: 'Tracy' },
      { label: 'Alhambra' },
      { label: 'Livermore' },
      { label: 'Buena Park' },
      { label: 'Menifee' },
      { label: 'Hemet' },
      { label: 'Lakewood' },
      { label: 'Merced' },
      { label: 'Chino' },
      { label: 'Indio' },
      { label: 'Redwood City' },
      { label: 'Lake Forest' },
      { label: 'Napa' },
      { label: 'Tustin' },
      { label: 'Bellflower' },
      { label: 'Mountain View' },
      { label: 'Chino Hills' },
      { label: 'Baldwin Park' },
      { label: 'Alameda' },
      { label: 'Upland' },
      { label: 'San Ramon' },
      { label: 'Folsom' },
      { label: 'Pleasanton' },
      { label: 'Union City' },
      { label: 'Perris' },
      { label: 'Manteca' },
      { label: 'Lynwood' },
      { label: 'Apple Valley' },
      { label: 'Redlands' },
      { label: 'Turlock' },
      { label: 'Milpitas' },
      { label: 'Redondo Beach' },
      { label: 'Rancho Cordova' },
      { label: 'Yorba Linda' },
      { label: 'Palo Alto' },
      { label: 'Davis' },
      { label: 'Camarillo' },
      { label: 'Walnut Creek' },
      { label: 'Pittsburg' },
      { label: 'South San Francisco' },
      { label: 'Yuba City' },
      { label: 'San Clemente' },
      { label: 'Laguna Niguel' },
      { label: 'Pico Rivera' },
      { label: 'Montebello' },
      { label: 'Lodi' },
      { label: 'Madera' },
      { label: 'Santa Cruz' },
      { label: 'La Habra' },
      { label: 'Encinitas' },
      { label: 'Monterey Park' },
      { label: 'Tulare' },
      { label: 'Cupertino' },
      { label: 'Gardena' },
      { label: 'National City' },
      { label: 'Rocklin' },
      { label: 'Petaluma' },
      { label: 'Huntington Park' },
      { label: 'San Rafael' },
      { label: 'La Mesa' },
      { label: 'Arcadia' },
      { label: 'Fountain Valley' },
      { label: 'Diamond Bar' },
      { label: 'Woodland' },
      { label: 'Santee' },
      { label: 'Lake Elsinore' },
      { label: 'Porterville' },
      { label: 'Paramount' },
      { label: 'Eastvale' },
      { label: 'Rosemead' },
      { label: 'Hanford' },
      { label: 'Highland' },
      { label: 'Brentwood' },
      { label: 'Novato' },
      { label: 'Colton' },
      { label: 'Cathedral City' },
      { label: 'Delano' },
      { label: 'Yucaipa' },
      { label: 'Watsonville' },
      { label: 'Placentia' },
      { label: 'Glendora' },
      { label: 'Gilroy' },
      { label: 'Palm Desert' },
      { label: 'Cerritos' },
      { label: 'West Sacramento' },
      { label: 'Aliso Viejo' },
      { label: 'Poway' },
      { label: 'La Mirada' },
      { label: 'Rancho Santa Margarita' },
      { label: 'Cypress' },
      { label: 'Dublin' },
      { label: 'Covina' },
      { label: 'Azusa' },
      { label: 'Palm Springs' },
      { label: 'San Luis Obispo' },
      { label: 'Ceres' },
      { label: 'San Jacinto' },
      { label: 'Lincoln' },
      { label: 'Newark' },
      { label: 'Lompoc' },
      { label: 'El Centro' },
      { label: 'Danville' },
      { label: 'Bell Gardens' },
      { label: 'Coachella' },
      { label: 'Rancho Palos Verdes' },
      { label: 'San Bruno' },
      { label: 'Rohnert Park' },
      { label: 'Brea' },
      { label: 'La Puente' },
      { label: 'Campbell' },
      { label: 'San Gabriel' },
      { label: 'Beaumont' },
      { label: 'Morgan Hill' },
      { label: 'Culver City' },
      { label: 'Calexico' },
      { label: 'Stanton' },
      { label: 'La Quinta' },
      { label: 'Pacifica' },
      { label: 'Montclair' },
      { label: 'Oakley' },
      { label: 'Monrovia' },
      { label: 'Los Banos' },
      { label: 'Martinez' }
    ]
  },
  {
    country: 'United States',
    state: 'Illinois',
    cities: [
      {},
      { label: 'Chicago' },
      { label: 'Aurora' },
      { label: 'Rockford' },
      { label: 'Joliet' },
      { label: 'Naperville' },
      { label: 'Springfield' },
      { label: 'Peoria' },
      { label: 'Elgin' },
      { label: 'Waukegan' },
      { label: 'Cicero' },
      { label: 'Champaign' },
      { label: 'Bloomington' },
      { label: 'Arlington Heights' },
      { label: 'Evanston' },
      { label: 'Decatur' },
      { label: 'Schaumburg' },
      { label: 'Bolingbrook' },
      { label: 'Palatine' },
      { label: 'Skokie' },
      { label: 'Des Plaines' },
      { label: 'Orland Park' },
      { label: 'Tinley Park' },
      { label: 'Oak Lawn' },
      { label: 'Berwyn' },
      { label: 'Mount Prospect' },
      { label: 'Normal' },
      { label: 'Wheaton' },
      { label: 'Hoffman Estates' },
      { label: 'Oak Park' },
      { label: 'Downers Grove' },
      { label: 'Elmhurst' },
      { label: 'Glenview' },
      { label: 'DeKalb' },
      { label: 'Lombard' },
      { label: 'Belleville' },
      { label: 'Moline' },
      { label: 'Buffalo Grove' },
      { label: 'Bartlett' },
      { label: 'Urbana' },
      { label: 'Quincy' },
      { label: 'Crystal Lake' },
      { label: 'Plainfield' },
      { label: 'Streamwood' },
      { label: 'Carol Stream' },
      { label: 'Romeoville' },
      { label: 'Rock Island' },
      { label: 'Hanover Park' },
      { label: 'Carpentersville' },
      { label: 'Wheeling' },
      { label: 'Park Ridge' },
      { label: 'Addison' },
      { label: 'Calumet City' }
    ]
  },
  {
    country: 'United States',
    state: 'Texas',
    cities: [
      {},
      { label: 'Houston' },
      { label: 'San Antonio' },
      { label: 'Dallas' },
      { label: 'Austin' },
      { label: 'Fort Worth' },
      { label: 'El Paso' },
      { label: 'Arlington' },
      { label: 'Corpus Christi' },
      { label: 'Plano' },
      { label: 'Laredo' },
      { label: 'Lubbock' },
      { label: 'Garland' },
      { label: 'Irving' },
      { label: 'Amarillo' },
      { label: 'Grand Prairie' },
      { label: 'Brownsville' },
      { label: 'Pasadena' },
      { label: 'McKinney' },
      { label: 'Mesquite' },
      { label: 'McAllen' },
      { label: 'Killeen' },
      { label: 'Frisco' },
      { label: 'Waco' },
      { label: 'Carrollton' },
      { label: 'Denton' },
      { label: 'Midland' },
      { label: 'Abilene' },
      { label: 'Beaumont' },
      { label: 'Round Rock' },
      { label: 'Odessa' },
      { label: 'Wichita Falls' },
      { label: 'Richardson' },
      { label: 'Lewisville' },
      { label: 'Tyler' },
      { label: 'College Station' },
      { label: 'Pearland' },
      { label: 'San Angelo' },
      { label: 'Allen' },
      { label: 'League City' },
      { label: 'Sugar Land' },
      { label: 'Longview' },
      { label: 'Edinburg' },
      { label: 'Mission' },
      { label: 'Bryan' },
      { label: 'Baytown' },
      { label: 'Pharr' },
      { label: 'Temple' },
      { label: 'Missouri City' },
      { label: 'Flower Mound' },
      { label: 'Harlingen' },
      { label: 'North Richland Hills' },
      { label: 'Victoria' },
      { label: 'Conroe' },
      { label: 'New Braunfels' },
      { label: 'Mansfield' },
      { label: 'Cedar Park' },
      { label: 'Rowlett' },
      { label: 'Port Arthur' },
      { label: 'Euless' },
      { label: 'Georgetown' },
      { label: 'Pflugerville' },
      { label: 'DeSoto' },
      { label: 'San Marcos' },
      { label: 'Grapevine' },
      { label: 'Bedford' },
      { label: 'Galveston' },
      { label: 'Cedar Hill' },
      { label: 'Texas City' },
      { label: 'Wylie' },
      { label: 'Haltom City' },
      { label: 'Keller' },
      { label: 'Coppell' },
      { label: 'Rockwall' },
      { label: 'Huntsville' },
      { label: 'Duncanville' },
      { label: 'Sherman' },
      { label: 'The Colony' },
      { label: 'Burleson' },
      { label: 'Hurst' },
      { label: 'Lancaster' },
      { label: 'Texarkana' },
      { label: 'Friendswood' },
      { label: 'Weslaco' }
    ]
  },
  {
    country: 'United States',
    state: 'Pennsylvania',
    cities: [
      {},
      { label: 'Aliquippa' },
      { label: 'Allentown' },
      { label: 'Altoona' },
      { label: 'Arnold' },
      { label: 'Beaver Falls' },
      { label: 'Bethlehem' },
      { label: 'Bloomsburg' },
      { label: 'Bradford' },
      { label: 'Butler' },
      { label: 'Carbondale' },
      { label: 'Chester' },
      { label: 'Clairton' },
      { label: 'Coatesville' },
      { label: 'Connellsville' },
      { label: 'Corry' },
      { label: 'Du Bois' },
      { label: 'Duquesne' },
      { label: 'Easton' },
      { label: 'Erie' },
      { label: 'Farrell' },
      { label: 'Franklin' },
      { label: 'Greensburg' },
      { label: 'Harrisburg' },
      { label: 'Hazleton' },
      { label: 'Hermitage' },
      { label: 'Jeannette' },
      { label: 'Johnstown' },
      { label: 'Lancaster' },
      { label: 'Latrobe' },
      { label: 'Lebanon' },
      { label: 'Lock Haven' },
      { label: 'Lower Burrell' },
      { label: 'McCandless' },
      { label: 'McKeesport' },
      { label: 'Meadville' },
      { label: 'Monessen' },
      { label: 'Monongahela' },
      { label: 'Nanticoke' },
      { label: 'New Castle' },
      { label: 'New Kensington' },
      { label: 'Oil City' },
      { label: 'Parker' },
      { label: 'Philadelphia' },
      { label: 'Pittsburgh' },
      { label: 'Pittston' },
      { label: 'Pottsville' },
      { label: 'Reading' },
      { label: 'St. Marys' },
      { label: 'Scranton' },
      { label: 'Shamokin' },
      { label: 'Sharon' },
      { label: 'Sunbury' },
      { label: 'Titusville' },
      { label: 'Uniontown' },
      { label: 'Warren' },
      { label: 'Washington' },
      { label: 'Wilkes-Barre' },
      { label: 'Williamsport' },
      { label: 'York' }
    ]
  },
  {
    country: 'United States',
    state: 'Arizona',
    cities: [
      {},
      { label: 'Phoenix' },
      { label: 'Tucson' },
      { label: 'Mesa' },
      { label: 'Chandler' },
      { label: 'Glendale' },
      { label: 'Scottsdale' },
      { label: 'Gilbert' },
      { label: 'Tempe' },
      { label: 'Peoria' },
      { label: 'Surprise' },
      { label: 'Yuma' },
      { label: 'Avondale' },
      { label: 'Goodyear' },
      { label: 'Flagstaff' },
      { label: 'Buckeye' },
      { label: 'Lake Havasu City' },
      { label: 'Casa Grande' },
      { label: 'Sierra Vista' },
      { label: 'Maricopa' },
      { label: 'Oro Valley' },
      { label: 'Prescott' },
      { label: 'Bullhead City' },
      { label: 'Prescott Valley' },
      { label: 'Marana' },
      { label: 'Apache Junction' }
    ]
  },
  {
    country: 'United States',
    state: 'Florida',
    cities: [
      {},
      { label: 'Jacksonville' },
      { label: 'Miami' },
      { label: 'Tampa' },
      { label: 'Orlando' },
      { label: 'St. Petersburg' },
      { label: 'Hialeah' },
      { label: 'Tallahassee' },
      { label: 'Fort Lauderdale' },
      { label: 'Port St. Lucie' },
      { label: 'Cape Coral' },
      { label: 'Pembroke Pines' },
      { label: 'Hollywood' },
      { label: 'Miramar' },
      { label: 'Gainesville' },
      { label: 'Coral Springs' },
      { label: 'Miami Gardens' },
      { label: 'Clearwater' },
      { label: 'Palm Bay' },
      { label: 'Pompano Beach' },
      { label: 'West Palm Beach' },
      { label: 'Lakeland' },
      { label: 'Davie' },
      { label: 'Miami Beach' },
      { label: 'Sunrise' },
      { label: 'Plantation' },
      { label: 'Boca Raton' },
      { label: 'Deltona' },
      { label: 'Largo' },
      { label: 'Deerfield Beach' },
      { label: 'Palm Coast' },
      { label: 'Melbourne' },
      { label: 'Boynton Beach' },
      { label: 'Lauderhill' },
      { label: 'Weston' },
      { label: 'Fort Myers' },
      { label: 'Kissimmee' },
      { label: 'Homestead' },
      { label: 'Tamarac' },
      { label: 'Delray Beach' },
      { label: 'Daytona Beach' },
      { label: 'North Miami' },
      { label: 'Wellington' },
      { label: 'North Port' },
      { label: 'Jupiter' },
      { label: 'Ocala' },
      { label: 'Port Orange' },
      { label: 'Margate' },
      { label: 'Coconut Creek' },
      { label: 'Sanford' },
      { label: 'Sarasota' },
      { label: 'Pensacola' },
      { label: 'Bradenton' },
      { label: 'Palm Beach Gardens' },
      { label: 'Pinellas Park' },
      { label: 'Coral Gables' },
      { label: 'Doral' },
      { label: 'Bonita Springs' },
      { label: 'Apopka' },
      { label: 'Titusville' },
      { label: 'North Miami Beach' },
      { label: 'Oakland Park' },
      { label: 'Fort Pierce' },
      { label: 'North Lauderdale' },
      { label: 'Cutler Bay' },
      { label: 'Altamonte Springs' },
      { label: 'St. Cloud' },
      { label: 'Greenacres' },
      { label: 'Ormond Beach' },
      { label: 'Ocoee' },
      { label: 'Hallandale Beach' },
      { label: 'Winter Garden' },
      { label: 'Aventura' }
    ]
  },
  {
    country: 'United States',
    state: 'Indiana',
    cities: [
      { label: 'Indianapolis' },
      { label: 'Fort Wayne' },
      { label: 'Evansville' },
      { label: 'South Bend' },
      { label: 'Carmel' },
      { label: 'Bloomington' },
      { label: 'Fishers' },
      { label: 'Hammond' },
      { label: 'Gary' },
      { label: 'Muncie' },
      { label: 'Lafayette' },
      { label: 'Terre Haute' },
      { label: 'Kokomo' },
      { label: 'Anderson' },
      { label: 'Noblesville' },
      { label: 'Greenwood' },
      { label: 'Elkhart' },
      { label: 'Mishawaka' },
      { label: 'Lawrence' },
      { label: 'Jeffersonville' },
      { label: 'Columbus' },
      { label: 'Portage' }
    ]
  },
  {
    country: 'United States',
    state: 'Ohio',
    cities: [
      {},
      { label: 'Columbus' },
      { label: 'Cleveland' },
      { label: 'Cincinnati' },
      { label: 'Toledo' },
      { label: 'Akron' },
      { label: 'Dayton' },
      { label: 'Parma' },
      { label: 'Canton' },
      { label: 'Youngstown' },
      { label: 'Lorain' },
      { label: 'Hamilton' },
      { label: 'Springfield' },
      { label: 'Kettering' },
      { label: 'Elyria' },
      { label: 'Lakewood' },
      { label: 'Cuyahoga Falls' },
      { label: 'Middletown' },
      { label: 'Euclid' },
      { label: 'Newark' },
      { label: 'Mansfield' },
      { label: 'Mentor' },
      { label: 'Beavercreek' },
      { label: 'Cleveland Heights' },
      { label: 'Strongsville' },
      { label: 'Dublin' },
      { label: 'Fairfield' },
      { label: 'Findlay' },
      { label: 'Warren' },
      { label: 'Lancaster' },
      { label: 'Lima' },
      { label: 'Huber Heights' },
      { label: 'Westerville' },
      { label: 'Marion' },
      { label: 'Grove City' }
    ]
  },
  {
    country: 'United States',
    state: 'North Carolina',
    cities: [
      {},
      { label: 'Charlotte' },
      { label: 'Raleigh' },
      { label: 'Greensboro' },
      { label: 'Durham' },
      { label: 'Winston-Salem' },
      { label: 'Fayetteville' },
      { label: 'Cary' },
      { label: 'Wilmington' },
      { label: 'High Point' },
      { label: 'Greenville' },
      { label: 'Asheville' },
      { label: 'Concord' },
      { label: 'Gastonia' },
      { label: 'Jacksonville' },
      { label: 'Chapel Hill' },
      { label: 'Rocky Mount' },
      { label: 'Burlington' },
      { label: 'Wilson' },
      { label: 'Huntersville' },
      { label: 'Kannapolis' },
      { label: 'Apex' },
      { label: 'Hickory' },
      { label: 'Goldsboro' }
    ]
  },
  {
    country: 'United States',
    state: 'Michigan',
    cities: [
      {},
      { label: 'Detroit' },
      { label: 'Grand Rapids' },
      { label: 'Warren' },
      { label: 'Sterling Heights' },
      { label: 'Ann Arbor' },
      { label: 'Lansing' },
      { label: 'Flint' },
      { label: 'Dearborn' },
      { label: 'Livonia' },
      { label: 'Westland' },
      { label: 'Troy' },
      { label: 'Farmington Hills' },
      { label: 'Kalamazoo' },
      { label: 'Wyoming' },
      { label: 'Southfield' },
      { label: 'Rochester Hills' },
      { label: 'Taylor' },
      { label: 'Pontiac' },
      { label: 'St. Clair Shores' },
      { label: 'Royal Oak' },
      { label: 'Novi' },
      { label: 'Dearborn Heights' },
      { label: 'Battle Creek' },
      { label: 'Saginaw' },
      { label: 'Kentwood' },
      { label: 'East Lansing' },
      { label: 'Roseville' },
      { label: 'Portage' },
      { label: 'Midland' },
      { label: 'Lincoln Park' },
      { label: 'Muskegon' }
    ]
  },
  {
    country: 'United States',
    state: 'Tennessee',
    cities: [
      {},
      { label: 'Memphis' },
      { label: 'Nashville-Davidson' },
      { label: 'Knoxville' },
      { label: 'Chattanooga' },
      { label: 'Clarksville' },
      { label: 'Murfreesboro' },
      { label: 'Jackson' },
      { label: 'Franklin' },
      { label: 'Johnson City' },
      { label: 'Bartlett' },
      { label: 'Hendersonville' },
      { label: 'Kingsport' },
      { label: 'Collierville' },
      { label: 'Cleveland' },
      { label: 'Smyrna' },
      { label: 'Germantown' },
      { label: 'Brentwood' }
    ]
  },
  {
    country: 'United States',
    state: 'Massachusetts',
    cities: [
      {},
      { label: 'Boston' },
      { label: 'Worcester' },
      { label: 'Springfield' },
      { label: 'Lowell' },
      { label: 'Cambridge' },
      { label: 'New Bedford' },
      { label: 'Brockton' },
      { label: 'Quincy' },
      { label: 'Lynn' },
      { label: 'Fall River' },
      { label: 'Newton' },
      { label: 'Lawrence' },
      { label: 'Somerville' },
      { label: 'Waltham' },
      { label: 'Haverhill' },
      { label: 'Malden' },
      { label: 'Medford' },
      { label: 'Taunton' },
      { label: 'Chicopee' },
      { label: 'Weymouth Town' },
      { label: 'Revere' },
      { label: 'Peabody' },
      { label: 'Methuen' },
      { label: 'Barnstable Town' },
      { label: 'Pittsfield' },
      { label: 'Attleboro' },
      { label: 'Everett' },
      { label: 'Salem' },
      { label: 'Westfield' },
      { label: 'Leominster' },
      { label: 'Fitchburg' },
      { label: 'Beverly' },
      { label: 'Holyoke' },
      { label: 'Marlborough' },
      { label: 'Woburn' },
      { label: 'Chelsea' }
    ]
  },
  {
    country: 'United States',
    state: 'Washington',
    cities: [
      {},
      { label: 'Aberdeen' },
      { label: 'Airway Heights' },
      { label: 'Albion' },
      { label: 'Alderwood' },
      { label: 'Algona' },
      { label: 'Allyn' },
      { label: 'Almira' },
      { label: 'Amanda Park' },
      { label: 'Amboy' },
      { label: 'American River' },
      { label: 'Anacortes' },
      { label: 'Anatone' },
      { label: 'Anderson Island' },
      { label: 'Arlington' },
      { label: 'Ashford' },
      { label: 'Asotin' },
      { label: 'Auburn' },
      { label: 'Aukeen' },
      { label: 'Bainbridge Island' },
      { label: 'Bangor' },
      { label: 'Baring' },
      { label: 'Barstow' },
      { label: 'Battle Ground' },
      { label: 'Belfair' },
      { label: 'Bellevue' },
      { label: 'Bellingham' },
      { label: 'Benton City' },
      { label: 'Beverly' },
      { label: 'Bingen' },
      { label: 'Birch Bay' },
      { label: 'Black Diamond' },
      { label: 'Blaine' },
      { label: 'Bonney Lake' },
      { label: 'Bothell' },
      { label: 'Bow' },
      { label: 'Bremerton' },
      { label: 'Brewster' },
      { label: 'Bridgeport' },
      { label: 'Brier' },
      { label: 'Brinnon' },
      { label: 'Brownsville' },
      { label: 'Buckley' },
      { label: 'Bucoda' },
      { label: 'Burien' },
      { label: 'Burley' },
      { label: 'Burlington' },
      { label: 'Camano Island' },
      { label: 'Camas' },
      { label: 'Canyon Park' },
      { label: 'Carbonado' },
      { label: 'Carnation' },
      { label: 'Carson' },
      { label: 'Cascade' },
      { label: 'Cashmere' },
      { label: 'Castle Rock' },
      { label: 'Cathan' },
      { label: 'Cathart' },
      { label: 'Cathlamet' },
      { label: 'Central Park' },
      { label: 'Centralia' },
      { label: 'Chehalis' },
      { label: 'Chelan' },
      { label: 'Cheney' },
      { label: 'Chewelah' },
      { label: 'Chico' },
      { label: 'Chinook' },
      { label: 'Clarkston' },
      { label: 'Cle Elum' },
      { label: 'Clinton' },
      { label: 'Clyde Hill' },
      { label: 'Coles Corner' },
      { label: 'Colfax' },
      { label: 'College Place' },
      { label: 'Colton' },
      { label: 'Colville' },
      { label: 'Concrete' },
      { label: 'Conconully' },
      { label: 'Cosmopolis' },
      { label: 'Cougar' },
      { label: 'Coulee City' },
      { label: 'Coulee Dam' },
      { label: 'Coupeville' },
      { label: 'Crescent Bar' },
      { label: 'Crystal Mountain' },
      { label: 'Cusick' },
      { label: 'Darrington' },
      { label: 'Davenport' },
      { label: 'Dayton' },
      { label: 'Deer Park' },
      { label: 'Deming' },
      { label: 'Des Moines' },
      { label: 'Diablo' },
      { label: 'Discovery Bay' },
      { label: 'Dishman' },
      { label: 'Dupont' },
      { label: 'Duvall' },
      { label: 'Eatonville' },
      { label: 'Easton' },
      { label: 'Echo Lake' },
      { label: 'Edgewood' },
      { label: 'Edmonds' },
      { label: 'Elbe' },
      { label: 'Eldon' },
      { label: 'Electric City' },
      { label: 'Ellensburg' },
      { label: 'Elma' },
      { label: 'Elmer City' },
      { label: 'Enumclaw' },
      { label: 'Ephrata' },
      { label: 'Evans' },
      { label: 'Everett' },
      { label: 'Federal Way' },
      { label: 'Ferndale' },
      { label: 'Fife' },
      { label: 'Firecrest' },
      { label: 'Forks' },
      { label: 'Fortson' },
      { label: 'Fox Island' },
      { label: 'Freeland' },
      { label: 'Friday Harbor' },
      { label: 'Garfield' },
      { label: 'George' },
      { label: 'Gig Harbor' },
      { label: 'Glacier' },
      { label: 'Glenoma' },
      { label: 'Glenwood' },
      { label: 'Goldbar' },
      { label: 'Goldendale' },
      { label: 'Gorst' },
      { label: 'Graham' },
      { label: 'Grand Coulee' },
      { label: 'Grandview' },
      { label: 'Granger' },
      { label: 'Granite Falls' },
      { label: 'Grandview' },
      { label: 'Grapeview' },
      { label: 'Greenbank' },
      { label: 'Greenwater' },
      { label: 'Guemes Island' },
      { label: 'Hansville' },
      { label: 'Harrah' },
      { label: 'Harrington' },
      { label: 'Hazel' },
      { label: 'Holly' },
      { label: 'Hood Canal' },
      { label: 'Hoodsport' },
      { label: 'Hoquiam' },
      { label: 'Humptulips' },
      { label: 'Husum' },
      { label: 'Ilwaco' },
      { label: 'Index' },
      { label: 'Indianola' },
      { label: 'Ione' },
      { label: 'Issaquah' },
      { label: 'Kalaloch' },
      { label: 'Kalama' },
      { label: 'Kelso' },
      { label: 'Kennewick' },
      { label: 'Kent' },
      { label: 'Kettle Falls' },
      { label: 'Key Center' },
      { label: 'Keyport' },
      { label: 'Kingston' },
      { label: 'Kirkland' },
      { label: 'Kittitas' },
      { label: 'Klickitat' },
      { label: 'La Conner' },
      { label: 'La Push' },
      { label: 'Lacey' },
      { label: 'Lake Stevens' },
      { label: 'Lakewood' },
      { label: 'Langley' },
      { label: 'Leavenworth' },
      { label: 'Liberty Lake' },
      { label: 'Lilliwaup' },
      { label: 'Little Boston' },
      { label: 'Long Beach' },
      { label: 'Longview' },
      { label: 'Lummi Island' },
      { label: 'Lyle' },
      { label: 'Lynden' },
      { label: 'Lynnwood' },
      { label: 'Machias' },
      { label: 'Maltby' },
      { label: 'Manchester' },
      { label: 'Manson' },
      { label: 'Maple Falls' },
      { label: 'Maple Valley' },
      { label: 'Marblemount' },
      { label: 'Marysville' },
      { label: 'Mattawa' },
      { label: 'McCleary' },
      { label: 'Mill Creek' },
      { label: 'Moxee City' },
      { label: 'Mazama' },
      { label: 'Medical Lake' },
      { label: 'Medina' },
      { label: 'Mercer Island' },
      { label: 'Metaline Falls' },
      { label: 'Methow' },
      { label: 'Mill Creek' },
      { label: 'Milton' },
      { label: 'Mineral' },
      { label: 'Moclips' },
      { label: 'Monroe' },
      { label: 'Montesano' },
      { label: 'Morton' },
      { label: 'Moses Lake' },
      { label: 'Mossyrock' },
      { label: 'Mount Adams' },
      { label: 'Mount Baker' },
      { label: 'Mount Vernon' },
      { label: 'Mountlake Terrace' },
      { label: 'Moxee City' },
      { label: 'Mukilteo' },
      { label: 'Naches' },
      { label: 'Nahcotta' },
      { label: 'Naselle' },
      { label: 'Navy Yard City' },
      { label: 'Neah Bay' },
      { label: 'Nespelem' },
      { label: 'Newhalem' },
      { label: 'Newport' },
      { label: 'Nile' },
      { label: 'Nooksack' },
      { label: 'North Bend' },
      { label: 'North Bonneville' },
      { label: 'Northwoods' },
      { label: 'Oak Harbor' },
      { label: 'Oakville' },
      { label: 'Ocean City' },
      { label: 'Ocean Park' },
      { label: 'Ocean Shores' },
      { label: 'Odessa' },
      { label: 'Okanogan' },
      { label: 'Olalla' },
      { label: 'Olympia' },
      { label: 'Omak' },
      { label: 'Opportunity' },
      { label: 'Orient' },
      { label: 'Oroville' },
      { label: 'Orting' },
      { label: 'Oso' },
      { label: 'Othello' },
      { label: 'Outlook' },
      { label: 'Ozette' },
      { label: 'Pacific Beach' },
      { label: 'Packwood' },
      { label: 'Pasco' },
      { label: 'Pateros' },
      { label: 'Paterson' },
      { label: 'Pe Ell' },
      { label: 'Peshastin' },
      { label: 'Plain' },
      { label: 'Pomeroy' },
      { label: 'Port Angeles' },
      { label: 'Port Gamble' },
      { label: 'Port Hadlock' },
      { label: 'Port Ludlow' },
      { label: 'Port Orchard' },
      { label: 'Port Townsend' },
      { label: 'Potlatch' },
      { label: 'Poulsbo' },
      { label: 'Prescott' },
      { label: 'Prosser' },
      { label: 'Pullman' },
      { label: 'Purdy' },
      { label: 'Puyallup' },
      { label: 'Quilcene' },
      { label: 'Quincy' },
      { label: 'Quinault' },
      { label: 'Randle' },
      { label: 'Raymond' },
      { label: 'Reardon' },
      { label: 'Redmond' },
      { label: 'Renton' },
      { label: 'Republic' },
      { label: 'Richland' },
      { label: 'Rimrock' },
      { label: 'Ritzville' },
      { label: 'Riverside' },
      { label: 'Robe' },
      { label: 'Rock Island' },
      { label: 'Rockport' },
      { label: 'Rosalia' },
      { label: 'Roslyn' },
      { label: 'Royal City' },
      { label: 'Salkum' },
      { label: 'Sammamish' },
      { label: 'Seabeck' },
      { label: 'SeaTac' },
      { label: 'Seattle' },
      { label: 'Seaview' },
      { label: 'Sedro Woolley' },
      { label: 'Selah' },
      { label: 'Sequim' },
      { label: 'Shelton' },
      { label: 'Shoreline' },
      { label: 'Silvana' },
      { label: 'Silverdale' },
      { label: 'Silverlake' },
      { label: 'Skamokawa' },
      { label: 'Skykomish' },
      { label: 'Smokey Point' },
      { label: 'Snohomish' },
      { label: 'Snoqualmie' },
      { label: 'Snoqualmie Pass' },
      { label: 'Soap Lake' },
      { label: 'South Bend' },
      { label: 'South Colby' },
      { label: 'Southworth' },
      { label: 'Spanaway' },
      { label: 'Spokane' },
      { label: 'Spokane Valley' },
      { label: 'Sprague' },
      { label: 'Springdale' },
      { label: 'Stanwood' },
      { label: 'Startup' },
      { label: 'Stehekin' },
      { label: 'Steilacoom' },
      { label: 'Stevens Pass' },
      { label: 'Stevenson' },
      { label: 'Sultan' },
      { label: 'Sumas' },
      { label: 'Sumner' },
      { label: 'Suquamish' },
      { label: 'Sultan' },
      { label: 'Sunnyside' },
      { label: 'Suquamish' },
      { label: 'Tacoma' },
      { label: 'Tahuya' },
      { label: 'Tekoa' },
      { label: 'Tenino' },
      { label: 'Thorp' },
      { label: 'Tokeland' },
      { label: 'Tonasket' },
      { label: 'Toppenish' },
      { label: 'Toutle' },
      { label: 'Tracyton' },
      { label: 'Trout Lake' },
      { label: 'Tukwila' },
      { label: 'Tulalip' },
      { label: 'Tumwater' },
      { label: 'Twisp' },
      { label: 'Union' },
      { label: 'Union Gap' },
      { label: 'Uniontown' },
      { label: 'Usk' },
      { label: 'Van Horn' },
      { label: 'Vancouver' },
      { label: 'Vantage' },
      { label: 'Vashon Island' },
      { label: 'Verlot' },
      { label: 'Waitsburg' },
      { label: 'Walla Walla' },
      { label: 'Wallula' },
      { label: 'Wapato' },
      { label: 'Warden' },
      { label: 'Washougal' },
      { label: 'Washtucna' },
      { label: 'Waterville' },
      { label: 'Wauconda' },
      { label: 'Wellpinit' },
      { label: 'Wenatchee' },
      { label: 'West Richland' }
    ]
  },
  {
    country: 'United States',
    state: 'Colorado',
    cities: [
      {},
      { label: 'Denver' },
      { label: 'Colorado Springs' },
      { label: 'Aurora' },
      { label: 'Fort Collins' },
      { label: 'Lakewood' },
      { label: 'Thornton' },
      { label: 'Arvada' },
      { label: 'Westminster' },
      { label: 'Pueblo' },
      { label: 'Centennial' },
      { label: 'Boulder' },
      { label: 'Greeley' },
      { label: 'Longmont' },
      { label: 'Loveland' },
      { label: 'Grand Junction' },
      { label: 'Broomfield' },
      { label: 'Castle Rock' },
      { label: 'Commerce City' },
      { label: 'Parker' },
      { label: 'Littleton' },
      { label: 'Northglenn' }
    ]
  },
  {
    country: 'United States',
    state: 'District of Columbia',
    cities: [{}, { label: 'Washington' }]
  },
  {
    country: 'United States',
    state: 'Maryland',
    cities: [
      {},
      { label: 'Baltimore' },
      { label: 'Frederick' },
      { label: 'Rockville' },
      { label: 'Gaithersburg' },
      { label: 'Bowie' },
      { label: 'Hagerstown' },
      { label: 'Annapolis' }
    ]
  },
  {
    country: 'United States',
    state: 'Kentucky',
    cities: [
      {},
      { label: 'Louisville/Jefferson County' },
      { label: 'Lexington-Fayette' },
      { label: 'Bowling Green' },
      { label: 'Owensboro' },
      { label: 'Covington' }
    ]
  },
  {
    country: 'United States',
    state: 'Oregon',
    cities: [
      {},
      { label: 'Portland' },
      { label: 'Eugene' },
      { label: 'Salem' },
      { label: 'Gresham' },
      { label: 'Hillsboro' },
      { label: 'Beaverton' },
      { label: 'Bend' },
      { label: 'Medford' },
      { label: 'Springfield' },
      { label: 'Corvallis' },
      { label: 'Albany' },
      { label: 'Tigard' },
      { label: 'Lake Oswego' },
      { label: 'Keizer' }
    ]
  },
  {
    country: 'United States',
    state: 'Oklahoma',
    cities: [
      {},
      { label: 'Oklahoma City' },
      { label: 'Tulsa' },
      { label: 'Norman' },
      { label: 'Broken Arrow' },
      { label: 'Lawton' },
      { label: 'Edmond' },
      { label: 'Moore' },
      { label: 'Midwest City' },
      { label: 'Enid' },
      { label: 'Stillwater' },
      { label: 'Muskogee' }
    ]
  },
  {
    country: 'United States',
    state: 'Wisconsin',
    cities: [
      {},
      { label: 'Milwaukee' },
      { label: 'Madison' },
      { label: 'Green Bay' },
      { label: 'Kenosha' },
      { label: 'Racine' },
      { label: 'Appleton' },
      { label: 'Waukesha' },
      { label: 'Eau Claire' },
      { label: 'Oshkosh' },
      { label: 'Janesville' },
      { label: 'West Allis' },
      { label: 'La Crosse' },
      { label: 'Sheboygan' },
      { label: 'Wauwatosa' },
      { label: 'Fond du Lac' },
      { label: 'New Berlin' },
      { label: 'Wausau' },
      { label: 'Brookfield' },
      { label: 'Greenfield' },
      { label: 'Beloit' }
    ]
  },
  {
    country: 'United States',
    state: 'Nevada',
    cities: [
      {},
      { label: 'Las Vegas' },
      { label: 'Henderson' },
      { label: 'Reno' },
      { label: 'North Las Vegas' },
      { label: 'Sparks' },
      { label: 'Carson City' }
    ]
  },
  {
    country: 'United States',
    state: 'New Mexico',
    cities: [
      {},
      { label: 'Albuquerque' },
      { label: 'Las Cruces' },
      { label: 'Rio Rancho' },
      { label: 'Santa Fe' },
      { label: 'Roswell' },
      { label: 'Farmington' },
      { label: 'Clovis' }
    ]
  },
  {
    country: 'United States',
    state: 'Missouri',
    cities: [
      {},
      { label: 'Kansas City' },
      { label: 'St. Louis' },
      { label: 'Springfield' },
      { label: 'Independence' },
      { label: 'Columbia' },
      { label: "Lee's Summit" },
      { label: "O'Fallon" },
      { label: 'St. Joseph' },
      { label: 'St. Charles' },
      { label: 'St. Peters' },
      { label: 'Blue Springs' },
      { label: 'Florissant' },
      { label: 'Joplin' },
      { label: 'Chesterfield' },
      { label: 'Jefferson City' },
      { label: 'Cape Girardeau' }
    ]
  },
  {
    country: 'United States',
    state: 'Virginia',
    cities: [
      {},
      { label: 'Virginia Beach' },
      { label: 'Norfolk' },
      { label: 'Chesapeake' },
      { label: 'Richmond' },
      { label: 'Newport News' },
      { label: 'Alexandria' },
      { label: 'Hampton' },
      { label: 'Roanoke' },
      { label: 'Portsmouth' },
      { label: 'Suffolk' },
      { label: 'Lynchburg' },
      { label: 'Harrisonburg' },
      { label: 'Leesburg' },
      { label: 'Charlottesville' },
      { label: 'Danville' },
      { label: 'Blacksburg' },
      { label: 'Manassas' }
    ]
  },
  {
    country: 'United States',
    state: 'Georgia',
    cities: [
      {},
      { label: 'Atlanta' },
      { label: 'Columbus' },
      { label: 'Augusta-Richmond County' },
      { label: 'Savannah' },
      { label: 'Athens-Clarke County' },
      { label: 'Sandy Springs' },
      { label: 'Roswell' },
      { label: 'Macon' },
      { label: 'Johns Creek' },
      { label: 'Albany' },
      { label: 'Warner Robins' },
      { label: 'Alpharetta' },
      { label: 'Marietta' },
      { label: 'Valdosta' },
      { label: 'Smyrna' },
      { label: 'Dunwoody' }
    ]
  },
  {
    country: 'United States',
    state: 'Nebraska',
    cities: [{}, { label: 'Omaha' }, { label: 'Lincoln' }, { label: 'Bellevue' }, { label: 'Grand Island' }]
  },
  {
    country: 'United States',
    state: 'Minnesota',
    cities: [
      {},
      { label: 'Minneapolis' },
      { label: 'St. Paul' },
      { label: 'Rochester' },
      { label: 'Duluth' },
      { label: 'Bloomington' },
      { label: 'Brooklyn Park' },
      { label: 'Plymouth' },
      { label: 'St. Cloud' },
      { label: 'Eagan' },
      { label: 'Woodbury' },
      { label: 'Maple Grove' },
      { label: 'Eden Prairie' },
      { label: 'Coon Rapids' },
      { label: 'Burnsville' },
      { label: 'Blaine' },
      { label: 'Lakeville' },
      { label: 'Minnetonka' },
      { label: 'Apple Valley' },
      { label: 'Edina' },
      { label: 'St. Louis Park' },
      { label: 'Mankato' },
      { label: 'Maplewood' },
      { label: 'Moorhead' },
      { label: 'Shakopee' }
    ]
  },
  {
    country: 'United States',
    state: 'Kansas',
    cities: [
      {},
      { label: 'Wichita' },
      { label: 'Overland Park' },
      { label: 'Kansas City' },
      { label: 'Olathe' },
      { label: 'Topeka' },
      { label: 'Lawrence' },
      { label: 'Shawnee' },
      { label: 'Manhattan' },
      { label: 'Lenexa' },
      { label: 'Salina' },
      { label: 'Hutchinson' }
    ]
  },
  {
    country: 'United States',
    state: 'Louisiana',
    cities: [
      {},
      { label: 'New Orleans' },
      { label: 'Baton Rouge' },
      { label: 'Shreveport' },
      { label: 'Lafayette' },
      { label: 'Lake Charles' },
      { label: 'Kenner' },
      { label: 'Bossier City' },
      { label: 'Monroe' },
      { label: 'Alexandria' }
    ]
  },
  {
    country: 'United States',
    state: 'Hawaii',
    cities: [
      {},
      { label: 'Ahuimanu' },
      { label: 'Aiea' },
      { label: 'Ainaloa' },
      { label: 'Anahola' },
      { label: 'Barbers Point Housing' },
      { label: 'Captain Cook' },
      { label: 'Eden Roc' },
      { label: 'Eleele' },
      { label: 'Ewa Beach' },
      { label: 'Ewa Gentry' },
      { label: 'Ewa Villages' },
      { label: 'Fern Acres' },
      { label: 'Fern Forest' },
      { label: 'Haiku-Pauwela' },
      { label: 'Halaula' },
      { label: 'Halawa' },
      { label: 'Haleiwa' },
      { label: 'Haliimaile' },
      { label: 'Hana' },
      { label: 'Hanalei' },
      { label: 'Hanamaulu' },
      { label: 'Hanapepe' },
      { label: 'Hauula' },
      { label: 'Hawaiian Acres' },
      { label: 'Hawaiian Beaches' },
      { label: 'Hawaiian Ocean View' },
      { label: 'Hawaiian Paradise Park' },
      { label: 'Hawi' },
      { label: 'Heeia' },
      { label: 'Hickam Housing' },
      { label: 'Hilo' },
      { label: 'Holualoa' },
      { label: 'Honalo' },
      { label: 'Honaunau-Napoopoo' },
      { label: 'Honokaa' },
      { label: 'Honolulu' },
      { label: 'Honomu' },
      { label: 'Iroquois Point' },
      { label: 'Kaaawa' },
      { label: 'Kaanapali' },
      { label: 'Kahaluu' },
      { label: 'Kahaluu-Keauhou' },
      { label: 'Kahuku' },
      { label: 'Kahului' },
      { label: 'Kailua CDP (Hawaii County)' },
      { label: 'Kailua CDP (Honolulu County)' },
      { label: 'Kalaheo' },
      { label: 'Kalaoa' },
      { label: 'Kalihiwai' },
      { label: 'Kaneohe' },
      { label: 'Kaneohe Station' },
      { label: 'Kapaa' },
      { label: 'Kapaau' },
      { label: 'Kapalua' },
      { label: 'Kaumakani' },
      { label: 'Kaunakakai' },
      { label: 'Kawela Bay' },
      { label: 'Keaau' },
      { label: 'Kealakekua' },
      { label: 'Kekaha' },
      { label: 'Kihei' },
      { label: 'Kilauea' },
      { label: 'Koloa' },
      { label: 'Kualapuu' },
      { label: 'Kukuihaele' },
      { label: 'Kurtistown' },
      { label: 'Lahaina' },
      { label: 'Laie' },
      { label: 'Lanai City' },
      { label: 'Laupahoehoe' },
      { label: 'Lawai' },
      { label: 'Leilani Estates' },
      { label: 'Lihue' },
      { label: 'Maalaea' },
      { label: 'Maili' },
      { label: 'Makaha' },
      { label: 'Makaha Valley' },
      { label: 'Makakilo City' },
      { label: 'Makawao' },
      { label: 'Maunaloa' },
      { label: 'Maunawili' },
      { label: 'Mililani Town' },
      { label: 'Mokuleia' },
      { label: 'Mountain View' },
      { label: 'Naalehu' },
      { label: 'Nanakuli' },
      { label: 'Nanawale Estates' },
      { label: 'Napili-Honokowai' },
      { label: 'Omao' },
      { label: 'Orchidlands Estates' },
      { label: 'Paauilo' },
      { label: 'Pahala' },
      { label: 'Pahoa' },
      { label: 'Paia' },
      { label: 'Pakala Village' },
      { label: 'Papaikou' },
      { label: 'Paukaa' },
      { label: 'Pearl City' },
      { label: 'Pepeekeo' },
      { label: 'Poipu' },
      { label: 'Princeville' },
      { label: 'Puako' },
      { label: 'Puhi' },
      { label: 'Pukalani' },
      { label: 'Punaluu' },
      { label: 'Pupukea' },
      { label: 'Schofield Barracks' },
      { label: 'Village Park' },
      { label: 'Volcano' },
      { label: 'Wahiawa' },
      { label: 'Waialua' },
      { label: 'Waianae' },
      { label: 'Waihee-Waiehu' },
      { label: 'Waikane' },
      { label: 'Waikapu' },
      { label: 'Waikoloa Village' },
      { label: 'Wailea-Makena' },
      { label: 'Wailua' },
      { label: 'Wailua Homesteads' },
      { label: 'Wailuku' },
      { label: 'Waimalu' },
      { label: 'Waimanalo' },
      { label: 'Waimanalo Beach' },
      { label: 'Waimea CDP (Hawaii County)' },
      { label: 'Waimea CDP (Kauai County)' },
      { label: 'Wainaku' },
      { label: 'Waipahu' },
      { label: 'Waipio' },
      { label: 'Waipio Acres' },
      { label: 'Wheeler AFB' },
      { label: 'Whitmore Village' }
    ]
  },
  {
    country: 'United States',
    state: 'Alaska',
    cities: [{}, { label: 'Anchorage' }]
  },
  {
    country: 'United States',
    state: 'New Jersey',
    cities: [
      {},
      { label: 'Newark' },
      { label: 'Jersey City' },
      { label: 'Paterson' },
      { label: 'Elizabeth' },
      { label: 'Clifton' },
      { label: 'Trenton' },
      { label: 'Camden' },
      { label: 'Passaic' },
      { label: 'Union City' },
      { label: 'Bayonne' },
      { label: 'East Orange' },
      { label: 'Vineland' },
      { label: 'New Brunswick' },
      { label: 'Hoboken' },
      { label: 'Perth Amboy' },
      { label: 'West New York' },
      { label: 'Plainfield' },
      { label: 'Hackensack' },
      { label: 'Sayreville' },
      { label: 'Kearny' },
      { label: 'Linden' },
      { label: 'Atlantic City' }
    ]
  },
  {
    country: 'United States',
    state: 'Idaho',
    cities: [
      {},
      { label: 'Boise City' },
      { label: 'Nampa' },
      { label: 'Meridian' },
      { label: 'Idaho Falls' },
      { label: 'Pocatello' },
      { label: 'Caldwell' },
      { label: "Coeur d'Alene" },
      { label: 'Twin Falls' }
    ]
  },
  {
    country: 'United States',
    state: 'Alabama',
    cities: [
      {},
      { label: 'Birmingham' },
      { label: 'Montgomery' },
      { label: 'Mobile' },
      { label: 'Huntsville' },
      { label: 'Tuscaloosa' },
      { label: 'Hoover' },
      { label: 'Dothan' },
      { label: 'Auburn' },
      { label: 'Decatur' },
      { label: 'Madison' },
      { label: 'Florence' },
      { label: 'Gadsden' }
    ]
  },
  {
    country: 'United States',
    state: 'Iowa',
    cities: [
      {},
      { label: 'Des Moines' },
      { label: 'Cedar Rapids' },
      { label: 'Davenport' },
      { label: 'Sioux City' },
      { label: 'Iowa City' },
      { label: 'Waterloo' },
      { label: 'Council Bluffs' },
      { label: 'Ames' },
      { label: 'West Des Moines' },
      { label: 'Dubuque' },
      { label: 'Ankeny' },
      { label: 'Urbandale' },
      { label: 'Cedar Falls' }
    ]
  },
  {
    country: 'United States',
    state: 'Arkansas',
    cities: [
      {},
      { label: 'Little Rock' },
      { label: 'Fort Smith' },
      { label: 'Fayetteville' },
      { label: 'Springdale' },
      { label: 'Jonesboro' },
      { label: 'North Little Rock' },
      { label: 'Conway' },
      { label: 'Rogers' },
      { label: 'Pine Bluff' },
      { label: 'Bentonville' }
    ]
  },
  {
    country: 'United States',
    state: 'Utah',
    cities: [
      {},
      { label: 'Bountiful' },
      { label: 'Draper' },
      { label: 'Salt Lake City' },
      { label: 'Layton' },
      { label: 'Lehi' },
      { label: 'Logan' },
      { label: 'Murray' },
      { label: 'Ogden' },
      { label: 'Orem' },
      { label: 'Provo' },
      { label: 'Riverton' },
      { label: 'Roy' },
      { label: 'Sandy' },
      { label: 'South Jordan' },
      { label: 'St. George' },
      { label: 'Taylorsville' },
      { label: 'West Jordan' },
      { label: 'West Valley City' }
    ]
  },
  {
    country: 'United States',
    state: 'Rhode Island',
    cities: [
      {},
      { label: 'Cranston' },
      { label: 'East Providence' },
      { label: 'Pawtucket' },
      { label: 'Providence' },
      { label: 'Warwick' },
      { label: 'Woonsocket' }
    ]
  },
  {
    country: 'United States',
    state: 'Mississippi',
    cities: [
      {},
      { label: 'Biloxi' },
      { label: 'Gulfport' },
      { label: 'Hattiesburg' },
      { label: 'Jackson' },
      { label: 'Meridian' },
      { label: 'Southaven' }
    ]
  },
  {
    country: 'United States',
    state: 'South Dakota',
    cities: [{}, { label: 'Rapid City' }, { label: 'Sioux Falls' }]
  },
  {
    country: 'United States',
    state: 'Connecticut',
    cities: [
      {},
      { label: 'Bridgeport' },
      { label: 'Bristol' },
      { label: 'Danbury' },
      { label: 'Hartford' },
      { label: 'Meriden' },
      { label: 'Milford' },
      { label: 'Middletown' },
      { label: 'New Britain' },
      { label: 'New Haven' },
      { label: 'Norwalk' },
      { label: 'Norwich' },
      { label: 'Shelton' },
      { label: 'Stamford' },
      { label: 'Waterbury' },
      { label: 'West Haven' }
    ]
  },
  {
    country: 'United States',
    state: 'South Carolina',
    cities: [
      {},
      { label: 'Columbia' },
      { label: 'Charleston' },
      { label: 'Florence' },
      { label: 'Greenville' },
      { label: 'Goose Creek' },
      { label: 'Hilton Head Island' },
      { label: 'Mount Pleasant' },
      { label: 'North Charleston' },
      { label: 'Rock Hill' },
      { label: 'Summerville' },
      { label: 'Sumter' },
      { label: 'Spartanburg' }
    ]
  },
  {
    country: 'United States',
    state: 'New Hampshire',
    cities: [
      {},
      { label: 'Acworth' },
      { label: 'Albany' },
      { label: 'Alexandria' },
      { label: 'Allenstown' },
      { label: 'Alstead' },
      { label: 'Alton' },
      { label: 'Amherst' },
      { label: 'Andover' },
      { label: 'Antrim' },
      { label: 'Ashland' },
      { label: 'Atkinson' },
      { label: 'Auburn' },
      { label: 'Barnstead' },
      { label: 'Barrington' },
      { label: 'Bartlett' },
      { label: 'Bath' },
      { label: 'Bedford' },
      { label: 'Belmont' },
      { label: 'Bennington' },
      { label: 'Benton' },
      { label: 'Berlin' },
      { label: 'Bethlehem' },
      { label: 'Boscawen' },
      { label: 'Bow' },
      { label: 'Bradford' },
      { label: 'Brentwood' },
      { label: 'Bridgewater' },
      { label: 'Bristol' },
      { label: 'Brookfield' },
      { label: 'Brookline' },
      { label: 'Campton' },
      { label: 'Canaan' },
      { label: 'Candia' },
      { label: 'Canterbury' },
      { label: 'Carroll' },
      { label: 'Center Harbor' },
      { label: 'Charlestown' },
      { label: 'Chatham' },
      { label: 'Chester' },
      { label: 'Chesterfield' },
      { label: 'Chichester' },
      { label: 'Claremont' },
      { label: 'Clarksville' },
      { label: 'Colebrook' },
      { label: 'Columbia' },
      { label: 'Concord' },
      { label: 'Conway' },
      { label: 'Cornish' },
      { label: 'Croydon' },
      { label: 'Dalton' },
      { label: 'Danbury' },
      { label: 'Danville' },
      { label: 'Deerfield' },
      { label: 'Deering' },
      { label: 'Derry' },
      { label: 'Dorchester' },
      { label: 'Dover' },
      { label: 'Dublin' },
      { label: 'Dummer' },
      { label: 'Dunbarton' },
      { label: 'Durham' },
      { label: 'East Kingston' },
      { label: 'Easton' },
      { label: 'Eaton' },
      { label: 'Effingham' },
      { label: 'Ellsworth' },
      { label: 'Enfield' },
      { label: 'Epping' },
      { label: 'Epsom' },
      { label: 'Errol' },
      { label: 'Exeter' },
      { label: 'Farmington' },
      { label: 'Fitzwilliam' },
      { label: 'Francestown' },
      { label: 'Franconia' },
      { label: 'Franklin' },
      { label: 'Freedom' },
      { label: 'Fremont' },
      { label: 'Gilford Belknap' },
      { label: 'Gilmanton' },
      { label: 'Gilsum' },
      { label: 'Goffstown' },
      { label: 'Gorham' },
      { label: 'Goshen' },
      { label: 'Grafton' },
      { label: 'Grantham' },
      { label: 'Greenfield' },
      { label: 'Greenland' },
      { label: 'Greenville' },
      { label: 'Groton' },
      { label: 'Hampstead' },
      { label: 'Hampton' },
      { label: 'Hampton Falls' },
      { label: 'Hancock' },
      { label: 'Hanover' },
      { label: 'Harrisville' },
      { label: "Hart's Location" },
      { label: 'Haverhill' },
      { label: 'Hebron' },
      { label: 'Henniker' },
      { label: 'Hill' },
      { label: 'Hillsborough' },
      { label: 'Hinsdale' },
      { label: 'Holderness' },
      { label: 'Hollis' },
      { label: 'Hooksett' },
      { label: 'Hopkinton' },
      { label: 'Hudson' },
      { label: 'Jackson' },
      { label: 'Jaffrey' },
      { label: 'Jefferson' },
      { label: 'Keene' },
      { label: 'Kensington' },
      { label: 'Kingston' },
      { label: 'Laconia' },
      { label: 'Lancaster' },
      { label: 'Landaff' },
      { label: 'Langdon' },
      { label: 'Lebanon' },
      { label: 'Lee' },
      { label: 'Lempster' },
      { label: 'Lincoln' },
      { label: 'Lisbon' },
      { label: 'Litchfield' },
      { label: 'Littleton' },
      { label: 'Londonderry' },
      { label: 'Loudon' },
      { label: 'Lyman' },
      { label: 'Lyme' },
      { label: 'Lyndeborough' },
      { label: 'Madbury' },
      { label: 'Madison' },
      { label: 'Manchester' },
      { label: 'Marlborough' },
      { label: 'Marlow' },
      { label: 'Mason' },
      { label: 'Meredith' },
      { label: 'Merrimack' },
      { label: 'Middleton' },
      { label: 'Milan' },
      { label: 'Milford' },
      { label: 'Milton' },
      { label: 'Monroe' },
      { label: 'Mont Vernon' },
      { label: 'Moultonborough' },
      { label: 'Nashua' },
      { label: 'Nelson' },
      { label: 'New Boston' },
      { label: 'New Castle' },
      { label: 'New Durham' },
      { label: 'New Hampton' },
      { label: 'New Ipswich' },
      { label: 'New London' },
      { label: 'Newbury' },
      { label: 'Newfields' },
      { label: 'Newington' },
      { label: 'Newmarket' },
      { label: 'Newport' },
      { label: 'Newton' },
      { label: 'North Hampton' },
      { label: 'Northfield' },
      { label: 'Northumberland' },
      { label: 'Northwood' },
      { label: 'Nottingham' },
      { label: 'Orange' },
      { label: 'Orford' },
      { label: 'Ossipee' },
      { label: 'Pelham' },
      { label: 'Pembroke' },
      { label: 'Peterborough' },
      { label: 'Piermont' },
      { label: 'Pittsburg' },
      { label: 'Pittsfield' },
      { label: 'Plainfield' },
      { label: 'Plaistow' },
      { label: 'Plymouth' },
      { label: 'Portsmouth' },
      { label: 'Randolph' },
      { label: 'Raymond' },
      { label: 'Richmond' },
      { label: 'Rindge' },
      { label: 'Rochester' },
      { label: 'Rollinsford' },
      { label: 'Roxbury' },
      { label: 'Rumney' },
      { label: 'Rye' },
      { label: 'Salem' },
      { label: 'Salisbury' },
      { label: 'Sanbornton' },
      { label: 'Sandown' },
      { label: 'Sandwich' },
      { label: 'Seabrook' },
      { label: 'Sharon' },
      { label: 'Shelburne' },
      { label: 'Somersworth' },
      { label: 'South Hampton' },
      { label: 'Springfield' },
      { label: 'Stark' },
      { label: 'Stewartstown' },
      { label: 'Stoddard' },
      { label: 'Strafford' },
      { label: 'Stratford' },
      { label: 'Stratham' },
      { label: 'Sugar Hill' },
      { label: 'Sullivan' },
      { label: 'Sunapee' },
      { label: 'Surry' },
      { label: 'Sutton' },
      { label: 'Swanzey' },
      { label: 'Tamworth' },
      { label: 'Temple' },
      { label: 'Thornton' },
      { label: 'Tilton' },
      { label: 'Troy' },
      { label: 'Tuftonboro' },
      { label: 'Unity' },
      { label: 'Wakefield' },
      { label: 'Walpole' },
      { label: 'Warner' },
      { label: 'Warren' },
      { label: 'Washington' },
      { label: 'Waterville' },
      { label: 'Weare' },
      { label: 'Webster' },
      { label: 'Wentworth' },
      { label: 'Westmoreland' },
      { label: 'Whitefield' },
      { label: 'Wilmot' },
      { label: 'Wilton' },
      { label: 'Winchester' },
      { label: 'Windham' },
      { label: 'Windsor' },
      { label: 'Wolfeboro' },
      { label: 'Woodstock' }
    ]
  },
  {
    country: 'United States',
    state: 'North Dakota',
    cities: [{}, { label: 'Fargo' }, { label: 'Bismarck' }, { label: 'Grand Forks' }, { label: 'Minot' }]
  },
  {
    country: 'United States',
    state: 'Montana',
    cities: [{}, { label: 'Billings' }, { label: 'Bozeman' }, { label: 'Great Falls' }, { label: 'Missoula' }]
  },
  {
    country: 'United States',
    state: 'Delaware',
    cities: [{}, { label: 'Dover' }, { label: 'Wilmington' }]
  },
  {
    country: 'United States',
    state: 'Maine',
    cities: [{}, { label: 'Portland' }]
  },
  {
    country: 'United States',
    state: 'Wyoming',
    cities: [{}, { label: 'Cheyenne' }, { label: 'Casper' }]
  },
  {
    country: 'United States',
    state: 'West Virginia',
    cities: [{}, { label: 'Charleston' }, { label: 'Huntington' }]
  },
  {
    country: 'United States',
    state: 'Vermont',
    cities: [{}, { label: 'Burlington' }]
  },
  {
    country: 'United States',
    state: 'American Samoa',
    cities: [
      {},
      { label: 'Apia' },
      { label: 'Vaitele' },
      { label: 'Faleasiu' },
      { label: "Le'auva'a" },
      { label: 'Vailele' },
      { label: 'Siusega' },
      { label: "Fale'ula" },
      { label: 'Vaiusu' },
      { label: 'Malie' },
      { label: "Lauli'i" },
      { label: "Fasito'outa" },
      { label: 'Afega' },
      { label: "Nofoali'i" }
    ]
  },
  {
    country: 'United States',
    state: 'District of Columbia (DC)',
    cities: [{}, { label: 'Washington DC' }]
  },
  {
    country: 'Canada',
    state: 'Alberta',
    cities: [
      {},
      { label: 'Airdrie' },
      { label: 'Beaumont' },
      { label: 'Breton' },
      { label: 'Bonnyville' },
      { label: 'Brazeau' },
      { label: 'Calgary' },
      { label: 'Camrose' },
      { label: 'Canmore' },
      { label: 'Didzbury' },
      { label: 'Drayton Valley' },
      { label: 'Edmonton' },
      { label: 'Ft. Saskatchewan' },
      { label: 'Grande Prairie' },
      { label: 'Hanna' },
      { label: 'Hinton' },
      { label: 'Irricana' },
      { label: 'Lacombe' },
      { label: 'Leduc' },
      { label: 'Lethbridge' },
      { label: 'McLennan' },
      { label: 'Medicine Hat' },
      { label: 'Olds' },
      { label: 'Onoway' },
      { label: 'Provost' },
      { label: 'Red Deer' },
      { label: 'St. Albert' },
      { label: 'Spruce Grove' },
      { label: 'Strathcona County' },
      { label: 'Strathmore' },
      { label: 'Sylvan Lake' },
      { label: 'Swan Hills' },
      { label: 'Taber' },
      { label: 'Turner Valley' },
      { label: 'Vermillion' },
      { label: 'Wood Buffalo' }
    ]
  },
  {
    country: 'Canada',
    state: 'British Columbia',
    cities: [
      {},
      { label: 'Burnaby' },
      { label: 'Cache Creek' },
      { label: 'Castlegar' },
      { label: 'Chilliwack' },
      { label: 'Chemainus' },
      { label: 'City of Port Moody' },
      { label: 'Colwood' },
      { label: 'Clearwater' },
      { label: 'Coquitlam' },
      { label: 'Cranbrook' },
      { label: 'Dawson Creek' },
      { label: 'Delta' },
      { label: 'Fernie' },
      { label: 'Invermere' },
      { label: 'Kamloops' },
      { label: 'Kaslo' },
      { label: 'Langley' },
      { label: 'Lumby' },
      { label: 'Maple Ridge' },
      { label: 'Mission' },
      { label: 'Merritt' },
      { label: 'Nanaimo' },
      { label: 'Nelson' },
      { label: 'New Westminster' },
      { label: 'North Cowichan' },
      { label: 'North Vancouver' },
      { label: 'Osoyoos' },
      { label: 'Parksville' },
      { label: 'Peace River' },
      { label: 'Penticton' },
      { label: 'Port Hardy' },
      { label: 'Port Alberni' },
      { label: 'Prince George' },
      { label: 'Prince Rupert' },
      { label: 'Richmond' },
      { label: 'Saanich' },
      { label: 'Sooke' },
      { label: 'Sparwood' },
      { label: 'Surrey' },
      { label: 'Terrace' },
      { label: 'Tumbler' },
      { label: 'Vancouver' },
      { label: 'Vernon' },
      { label: 'Victoria' },
      { label: 'Whistler' }
    ]
  },
  {
    country: 'Canada',
    state: 'Manitoba',
    cities: [
      {},
      { label: 'Birtle' },
      { label: 'Brandon' },
      { label: 'Cranberry Portage' },
      { label: 'Dauphin' },
      { label: 'Flin Flon' },
      { label: 'Snow Lake' },
      { label: 'Steinbach' },
      { label: 'Stonewall' },
      { label: 'Swan River' },
      { label: 'The Pas' },
      { label: 'Thompson' },
      { label: 'Winnipeg' }
    ]
  },
  {
    country: 'Canada',
    state: 'New Brunswick',
    cities: [
      {},
      { label: 'Cap-Pele' },
      { label: 'Fredericton' },
      { label: 'Grand Bay-Westfield' },
      { label: 'Grand Falls' },
      { label: 'Memramcook' },
      { label: 'Miramichi' },
      { label: 'Moncton' },
      { label: 'Oromocto' },
      { label: 'Port Elgin' },
      { label: 'Sackville' },
      { label: 'Saint John' },
      { label: 'Saint Stephen' },
      { label: 'Shippagan' },
      { label: 'Sussex' },
      { label: 'Tracadie-Sheila' }
    ]
  },
  {
    country: 'Canada',
    state: 'Newfoundland and Labrador',
    cities: [
      {},
      { label: 'Argentia' },
      { label: "Bishop's Falls" },
      { label: 'Botwood' },
      { label: 'Brigus' },
      { label: 'Corner Brook' },
      { label: 'Labrador City' },
      { label: 'Mount Pearl' },
      { label: 'Paradise' },
      { label: 'Portaux Basques' },
      { label: "St. John's" }
    ]
  },
  {
    country: 'Canada',
    state: 'Northwest Territories',
    cities: [
      {},
      { label: 'Fort Smith' },
      { label: 'Town of Hay River' },
      { label: 'Town of Inuvik' },
      { label: 'Yellowknife' }
    ]
  },
  {
    country: 'Canada',
    state: 'Nova Scotia',
    cities: [
      {},
      { label: 'Amherst' },
      { label: 'Annapolis' },
      { label: 'Argyle' },
      { label: 'Baddeck' },
      { label: 'Bridgewater' },
      { label: 'Cape Breton' },
      { label: 'Chester' },
      { label: 'County of Kings' },
      { label: 'Cumberland County' },
      { label: 'East Hants' },
      { label: 'Halifax' },
      { label: 'Hants County' },
      { label: 'Inverness County' },
      { label: 'Kentville' },
      { label: 'Lunenburg' },
      { label: 'Lunenburg County' },
      { label: 'Mahone Bay' },
      { label: 'New Glasgow' },
      { label: 'New Minas' },
      { label: 'Parrsboro' },
      { label: 'Pictou County' },
      { label: 'Pictou' },
      { label: 'Queens' },
      { label: 'Richmond' },
      { label: 'Shelburne' },
      { label: 'Stellarton' },
      { label: 'Truro' },
      { label: 'Windsor' },
      { label: 'Yarmouth' }
    ]
  },
  {
    country: 'Canada',
    state: 'Nunavut',
    cities: [{}, { label: 'Iqaluit' }, { label: 'Rankin Inlet' }, { label: 'Arviat' }, { label: 'Baker Lake' }]
  },
  {
    country: 'Canada',
    state: 'Ontario',
    cities: [
      {},
      { label: 'Ajax' },
      { label: 'Atikokan' },
      { label: 'Barrie' },
      { label: 'Belleville' },
      { label: 'Blandford-Blenheim' },
      { label: 'Blind River' },
      { label: 'Brampton' },
      { label: 'Brant' },
      { label: 'Brantford' },
      { label: 'Brock' },
      { label: 'Brockville' },
      { label: 'Burlington' },
      { label: 'Caledon' },
      { label: 'Cambridge' },
      { label: 'Chatham-Kent' },
      { label: 'Chesterville' },
      { label: 'Clarington' },
      { label: 'Cobourg' },
      { label: 'Cochrane' },
      { label: 'Collingwood' },
      { label: 'Cornwall' },
      { label: 'Cumberland' },
      { label: 'Deep River' },
      { label: 'Dundas' },
      { label: 'Durham' },
      { label: 'Dymond' },
      { label: 'Ear Falls' },
      { label: 'East Gwillimbury' },
      { label: 'East Zorra-Tavistock' },
      { label: 'Elgin' },
      { label: 'Elliot Lake' },
      { label: 'Flamborough' },
      { label: 'Fort Erie' },
      { label: 'Fort Frances' },
      { label: 'Gananoque' },
      { label: 'Georgina' },
      { label: 'Glanbrook' },
      { label: 'Gloucester' },
      { label: 'Goulbourn' },
      { label: 'Gravenhurst' },
      { label: 'Grimsby' },
      { label: 'Guelph' },
      { label: 'Halton' },
      { label: 'Peterborough' },
      { label: 'Haldimand-Norfork' },
      { label: 'Halton Hills' },
      { label: 'Hamilton' },
      { label: 'Hearst' },
      { label: 'Hamilton-Wentworth' },
      { label: 'Huntsville' },
      { label: 'Ingersoll' },
      { label: 'James' },
      { label: 'Kanata' },
      { label: 'Kincardine' },
      { label: 'King' },
      { label: 'Kingston' },
      { label: 'Kirkland Lake' },
      { label: 'Kitchener' },
      { label: 'Larder Lake' },
      { label: 'Leamington' },
      { label: 'Lennox-Addington' },
      { label: 'Lincoln' },
      { label: 'Lindsay' },
      { label: 'London' },
      { label: 'Loyalist Township' },
      { label: 'Markham' },
      { label: 'Merrickville' },
      { label: 'Metro Toronto' },
      { label: 'Milton' },
      { label: 'Mississauga' },
      { label: 'Nepean' },
      { label: 'Newmarket' },
      { label: 'Niagara' },
      { label: 'Niagara Falls' },
      { label: 'Niagara-on-the-Lake' },
      { label: 'North Bay' },
      { label: 'North Dorchester' },
      { label: 'North Dumfries' },
      { label: 'North York' },
      { label: 'Norwich' },
      { label: 'Oakville' },
      { label: 'Orangeville' },
      { label: 'Orillia' },
      { label: 'Osgoode' },
      { label: 'Oshawa' },
      { label: 'Ottawa' },
      { label: 'Ottawa-Carleton' },
      { label: 'Owen Sound' },
      { label: 'Pickering' },
      { label: 'Port Bruce' },
      { label: 'Port Burwell' },
      { label: 'Port Colborne' },
      { label: 'Port Hope' },
      { label: 'Prince Edward' },
      { label: 'Quinte West' },
      { label: 'Renfrew' },
      { label: 'Richmond Hill' },
      { label: 'Sarnia' },
      { label: 'Sault Ste. Marie' },
      { label: 'Scarborough' },
      { label: 'Scugog' },
      { label: 'Souix Lookout CoC Sioux Lookout' },
      { label: 'Smiths Falls' },
      { label: 'South-West Oxford' },
      { label: 'Stoney Creek' },
      { label: 'Stratford' },
      { label: 'Sudbury' },
      { label: 'St. Catharines' },
      { label: 'St. Thomas' },
      { label: 'Thorold' },
      { label: 'Temagami' },
      { label: 'Thunder Bay' },
      { label: 'Tillsonburg' },
      { label: 'Timmins' },
      { label: 'Toronto' },
      { label: 'Uxbridge' },
      { label: 'Vaughan' },
      { label: 'Wainfleet' },
      { label: 'Wasaga Beach' },
      { label: 'Waterloo' },
      { label: 'Waterloo' },
      { label: 'Welland' },
      { label: 'Wellesley' },
      { label: 'West Carleton' },
      { label: 'West Lincoln' },
      { label: 'Whitby' },
      { label: 'Wilmot' },
      { label: 'Windsor' },
      { label: 'Woolwich' },
      { label: 'York' }
    ]
  },
  {
    country: 'Canada',
    state: 'Prince Edward Island',
    cities: [
      {},
      { label: 'Alberton' },
      { label: 'Charlottetown' },
      { label: 'Cornwall' },
      { label: 'Montague' },
      { label: 'Souris' },
      { label: 'Stratford' },
      { label: 'Summerside' }
    ]
  },
  {
    country: 'Canada',
    state: 'Yukon',
    cities: [
      {},
      { label: 'Carmacks' },
      { label: 'Dawson' },
      { label: 'Faro' },
      { label: 'Haines Junction' },
      { label: 'Mayo' },
      { label: 'Teslin' },
      { label: 'Watson Lake' },
      { label: 'Whitehorse' }
    ]
  },
  {
    country: 'Canada',
    state: 'Saskatchewan',
    cities: [
      {},
      { label: 'Avonlea' },
      { label: 'Craik' },
      { label: 'Colonsay' },
      { label: 'Creighton' },
      { label: 'Eastend' },
      { label: 'Esterhazy' },
      { label: 'Gravelbourg' },
      { label: 'Melfort' },
      { label: 'Nipawin' },
      { label: 'Prince Albert' },
      { label: 'Regina' },
      { label: 'Saskatoon' },
      { label: 'Shell Lake' },
      { label: 'Swift Current' },
      { label: 'Tisdale' },
      { label: 'Unity' },
      { label: 'Weyburn' },
      { label: 'Wynyard' },
      { label: 'Yorkton' }
    ]
  },
  {
    country: 'Canada',
    state: 'Quebec',
    cities: [
      {},
      { label: 'Alma' },
      { label: 'Amos' },
      { label: 'Anjou' },
      { label: 'Aylmer' },
      { label: 'Beauport' },
      { label: 'Bromptonville' },
      { label: 'Brosssard' },
      { label: 'Chateauguay' },
      { label: 'Chicoutimi' },
      { label: 'Coaticook' },
      { label: 'Dorval' },
      { label: 'Drummondville' },
      { label: 'Fleurimont' },
      { label: 'Longueuil' },
      { label: 'Gaspe' },
      { label: 'Gatineau' },
      { label: 'Hull' },
      { label: 'Joliette' },
      { label: 'Jonquiere' },
      { label: 'Lachine' },
      { label: 'LaSalle' },
      { label: 'Laurentides' },
      { label: 'Laval' },
      { label: 'Lennoxville' },
      { label: 'Levis' },
      { label: 'Marieville' },
      { label: 'Mount Royal' },
      { label: 'Montreal' },
      { label: 'Montreal Region' },
      { label: 'Montreal-Est' },
      { label: 'Quebec' },
      { label: 'Saint-Leonard' },
      { label: 'Sherbrooke' },
      { label: 'Sorel' },
      { label: 'Thetford Mines' },
      { label: 'Victoriaville' }
    ]
  }
]
